import React, {ReactElement, useState} from "react";

import {Toast, ToastItem} from "components/toast";

type ToastContextProps = {
	updateToast: (newToast: ToastItem) => void;
	onError: (error) => void;
};

const ToastContext = React.createContext<ToastContextProps>({
	updateToast: () => undefined,
	onError: () => undefined,
});

const ToastContextProvider = (props: {children: ReactElement}): ReactElement => {
	const [toast, setToast] = useState<ToastItem>();

	const updateToast = (newToast: ToastItem): void => setToast(newToast);
	const onError = (error): void => updateToast({description: error.message, type: "failure"});

	return (
		<ToastContext.Provider value={{updateToast, onError}}>
			<Toast toastItem={toast} position="top"/>
			{props.children}
		</ToastContext.Provider>
	);
};

export {ToastContext, ToastContextProvider};
